module.exports = "mutation deleteMatchSave($id: Int!) {\n  deleteEntry(id: $id)\n}"